/*!== Additional JS code ==*/
$(document).ready(function () {
  var thisElementValue = 0;
  $('.PremiumProduct_wrapper input').on('change', function () {
    if ($(this).is(':checked')) {
      var thisElementValue = $(this).val();
      $('.gift-atc-js').removeClass('hide');
    } else {
      $('.gift-atc-js').addClass('hide');
    }
  });

  $(document).on('click', '.gift-atc-js', function (e) {
    e.preventDefault();
    alert();
    var variantId = $('.PremiumProduct_wrapper input').val();
    _addToCart(variantId)
  });

  var _addToCart = function (variantId) {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "JSON",
      data: {
        id: variantId
      },
      success: function (res) {
        $('.PremiumProduct_wrapper').next('.button--wrapper').find('button').trigger('click');
      }
    });
  };
});

/** JS for Personalized Product Widget **/
$(document).ready(function () {

  $('.customCuff').on('click', function () {
    $('.customCuff').removeClass('activeCuff');
    $(this).addClass('activeCuff');
  });
  
  $('.Personalized-tab').on('click', function () {
    var TabIndex = $(this).attr('data-index'),
        textLabel = $(this).find('.tabLabel').text();

    $('.Personalized-tab').removeClass('active-switcher');
    $(this).addClass('active-switcher');
    $('.Personalized--productTabsContent').removeClass('active-tab');
    $('.Personalized--productTabsContent input').attr("name", "");

    $('.Personalized--productTabsContent[data-index="' + TabIndex + '"]').addClass('active-tab');
    if (TabIndex === '3') {
      $('.Personalized--productTabsContent[data-index="' + TabIndex + '"] #morse-code').attr('name', 'properties[Morse code]');
    } else if (TabIndex === '2') {
      $('.Personalized--productTabsContent[data-index="' + TabIndex + '"] #text-engrave').attr('name', 'properties[Text]');
      $('.Personalized--productTabsContent[data-index="' + TabIndex + '"] .fontValue').attr('name', 'properties[Font]');
    } else{
      $('.Personalized--productTabsContent[data-index="' + TabIndex + '"] #latitude').attr('name', 'properties[Latitude]');
      $('.Personalized--productTabsContent[data-index="' + TabIndex + '"] #longtitude').attr('name', 'properties[Longitude]');
      $('.Personalized--productTabsContent[data-index="' + TabIndex + '"] .fontValue').attr('name', 'properties[Font]');
    }
  });

  $('#text-engrave').on('keyup', function () {
    let message = $(this).val();
    let leftWords = 22 - message.length;
    $('.text-engrave-remaining Count').text(leftWords);
  });

  var converter = {
    a: ".-",
    b: "-...",
    c: "-.-.",
    d: "-..",
    e: ".",
    f: "..-.",
    g: "--.",
    h: "....",
    i: "..",
    j: ".---",
    k: "-.-",
    l: ".-..",
    m: "--",
    n: "-.",
    o: "---",
    p: ".--.",
    q: "--.-",
    r: ".-.",
    s: "...",
    t: "-",
    u: "..-",
    v: "...-",
    w: ".--",
    x: "-..-",
    y: "-.--",
    z: "--..",
    1: ".----",
    2: "..---",
    3: "...--",
    4: "....-",
    5: ".....",
    6: "-....",
    7: "--...",
    8: "---..",
    9: "----.",
    0: "-----",
    ".": ".-.-.-",
    ",": "--..--",
    "?": "..--..",
    "'": ".----.",
    "!": "-.-.--",
    "/": "-..-.",
    "(": "-.--.",
    ")": "-.--.-",
    "&": ".-...",
    ":": "---...",
    ";": "-.-.-.",
    "=": "-...-",
    "+": ".-.-.",
    "-": "-....-",
    _: "..--.-",
    '"': ".-..-.",
    $: "...-..-",
    "@": ".--.-.",
    " ": " "
  };
  $('#morse-text').on('keyup', function () {
    var value = $(this).val();
    var output = '';
    if (value === '') {
      $('#morse-code').val('');
      return false;
    }
    for (var i = 0; i < value.length; i++) {
      output += converter[value.charAt(i).toLowerCase()];
    }
    $('#morse-code').val(output);
  });

  // Mapbox Initialization
  mapboxgl.accessToken = 'pk.eyJ1IjoiNXRoYXZlbnVlamV3ZWxyeSIsImEiOiJjbGlvM3NhZzcwYndlM2RwYzJwY25tcjNjIn0.a07xYpb4SOEbbfge4mWbLA';
  const map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/mapbox/streets-v12',
    center: [-122.25948, 37.87221],
    zoom: 12
  });

  const marker = new mapboxgl.Marker()
    .setLngLat([-122.25948, 37.87221])
    .addTo(map);

  const geocoder = new MapboxGeocoder({
    accessToken: mapboxgl.accessToken,
    mapboxgl: mapboxgl,
    marker: false,
    zoom: 7,
    placeholder: 'Search',
    flyTo: {
      duration: 0
    }
  });
  map.addControl(geocoder);

  map.on('load', () => {
    map.addSource('single-point', {
      'type': 'geojson',
      'data': {
        'type': 'FeatureCollection',
        'features': []
      }
    });

    map.addLayer({
      'id': 'point',
      'source': 'single-point',
      'type': 'circle',
      'paint': {
        'circle-radius': 10,
        'circle-color': '#448ee4'
      }
    });

    geocoder.on('result', (event) => {
      map.getSource('single-point').setData(event.result.geometry);
    });
  });

  geocoder.on('result', (ev, curve) => {
    var latString = ev.result.geometry.coordinates[1];
    var lngString = ev.result.geometry.coordinates[0];
    $('.mapboxgl-ctrl-geocoder--input').blur();

    var lat = JSON.stringify(latString);
    var lng = JSON.stringify(lngString);
    updateCoordinateInputs(lat, lng);
  });


  const geolocate = new mapboxgl.GeolocateControl({
    positionOptions: {
      enableHighAccuracy: true
    },
    trackUserLocation: true
  });
  map.addControl(geolocate);

  map.addControl(new mapboxgl.NavigationControl());
  function updateCoordinateInputs(lat, lng) {
    if (lat > 0) {
      lat = parseFloat(lat).toFixed(4) + "Â° N";
    } else {
      lat = parseFloat(lat).toFixed(4) + "Â° S";
    }

    if (lng > 0) {
      lng = parseFloat(lng).toFixed(4) + "Â° E";
    } else {
      lng = parseFloat(lng).toFixed(4) + "Â° W";
    }

    let dms = convertDDToDMS(lat, lng);
      lat = dms.latitude;
      lng = dms.longtitude;

    $('.map-coordinates #latitude').val(lat);
    $('.map-coordinates #longtitude').val(lng);
  }

  function _convertDDToDMS(coordinate) {
    var absolute = Math.abs(coordinate);
    var degrees = Math.floor(absolute);
    var minutesNotTruncated = (absolute - degrees) * 60;
    var minutes = Math.floor(minutesNotTruncated);
    var seconds = Math.round((minutesNotTruncated - minutes) * 60 * 100) / 100;
    if (coordinate < 0) degrees *= -1;
    return degrees + "°" + minutes + "'" + seconds.toFixed(2);
  }

  function convertDDToDMS(lat, lng) {
    lat = Number(String(lat).replace(/Â° \w/, ""));
    lng = Number(String(lng).replace(/Â° \w/, ""));
    var latitude = _convertDDToDMS(lat);
    var latitudeCardinal = lat > 0 ? '"N' : '"S';

    var longitude = _convertDDToDMS(lng);
    var longitudeCardinal = lng > 0 ? '"E' : '"W';

    return {
      latitude: latitude + latitudeCardinal,
      longtitude: longitude + longitudeCardinal
    };
  }

  $('.engrave-font-chooser-item').on('click',function(){
      $('.Personalized--productTabsContent.active-tab .engrave-font-chooser-item').removeClass('font-selected');
      $(this).addClass('font-selected');
      var fontValue = $(this).data('font'),
        fontName = fontValue.toLowerCase().split(" ").join('-');
      $('.Personalized--productTabsContent.active-tab').removeAttr('data-font');
      $('.Personalized--productTabsContent.active-tab').attr('data-font', 'engrave-font-'+ fontName);
      $('.fontValue').val(fontValue);
  });
});
/** JS for Personalized Product Widget **/